module.exports = __webpack_public_path__ + "img/tacet-cockpit.1d975618.gif";